import './search.scss';

const SearchComponent = {
  body: null,
  el: null,
  placeholder: '',
  searchBoxes: null,
  state: false,

  init() {
    this.body = document.querySelector('body');
    this.el = document.querySelectorAll('#search-component');

    this.el.forEach((elem) => {
      let eventTrigger = elem.querySelectorAll('.event-trigger')[0];
      let input = elem.querySelector('input');
      let closeWrapper = elem.querySelectorAll('.search__close--wrapper')[0];

      if (eventTrigger) {
        eventTrigger.addEventListener('click', () => {
          this.didInteract(elem);
          input.focus();
        });
      }

      if (input) {
        input.addEventListener('focus', () => {
          this.clearPlaceholder(input);
        });

        input.addEventListener('blur', () => {
          this.showPlaceholder(input);
        });
      }

      if (closeWrapper) {
        closeWrapper.addEventListener('click', () => {
          this.didInteract(elem);
        });
      }
    });

    window.addEventListener('resize', this.clearOverlay.bind(this));
  },

  initInline() {
    this.searchBoxes = document.querySelectorAll('.search-component--inline');

    this.searchBoxes.forEach((search) => {

    });
  },

  didInteract(elem) {
    let overlay = document.querySelector('#white-overlay');

    this.body.classList.toggle('search--open');
    elem.classList.toggle('search--open');
    this.state = !this.state;

    if (window.outerWidth <= 900) {
      overlay.style.opacity = this.state ? 1 : 0;
      overlay.style.display = this.state ? 'block' : 'none';
    }
  },

  clearOverlay() {
    let overlay = document.querySelector('#white-overlay');

    if (window.outerWidth > 768 && (overlay.style.opacity === 1 || overlay.style.display === 'block') && this.state) {
      overlay.style.opacity = 0;
      overlay.style.display = 'none';
    }
  },

  clearPlaceholder(input) {
    let placeholder = input.getAttribute('placeholder');
    input.setAttribute('data-placeholder', placeholder);
    input.setAttribute('placeholder', '');
  },

  showPlaceholder(input) {
    let placeholder = input.getAttribute('data-placeholder');
    input.setAttribute('placeholder', placeholder);
  }
};

export default SearchComponent;
